import {
  PHONE_REGEX,
  EMAIL_REGEX,
  NAME_FIELD_REGEX,
  VERIFY_CODE_REGEX,
  ZIP_CODE_REGEX,
} from "@/constants";
import {
  PHONE_ERROR_MESSAGE,
  EMAIL_ERROR_MESSAGE,
  FIRST_NAME_ERROR_MESSAGE,
  SECOND_NAME_ERROR_MESSAGE,
  VERIFY_CODE_ERROR_MESSAGE,
  ZIP_CODE_ERROR_MESSAGE,
  NAME_ERROR_MESSAGE,
} from "@/pages/quiz/base/questions/contactField/common";

export const phoneField = {
  regex: PHONE_REGEX,
  regexFailMessage: PHONE_ERROR_MESSAGE,
  required: true,
};

export const zipCodeField = {
  regex: ZIP_CODE_REGEX,
  regexFailMessage: ZIP_CODE_ERROR_MESSAGE,
  required: true,
};

export const emailField = {
  regex: EMAIL_REGEX,
  regexFailMessage: EMAIL_ERROR_MESSAGE,
  required: true,
};

export const firstNameField = {
  regex: NAME_FIELD_REGEX,
  regexFailMessage: FIRST_NAME_ERROR_MESSAGE,
  required: true,
  minLength: 2,
  maxLength: 50,
};

export const secondNameField = {
  regex: NAME_FIELD_REGEX,
  regexFailMessage: SECOND_NAME_ERROR_MESSAGE,
  required: true,
  minLength: 2,
  maxLength: 50,
};

export const verificationCodeField = {
  regex: VERIFY_CODE_REGEX,
  regexFailMessage: VERIFY_CODE_ERROR_MESSAGE,
  required: true,
};

export const nameField = {
  regex: NAME_FIELD_REGEX,
  regexFailMessage: NAME_ERROR_MESSAGE,
  required: true,
  minLength: 2,
  maxLength: 50,
};
